import React, { useState, useEffect, useRef } from 'react';
import { ClipLoader } from 'react-spinners';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { Editor } from '@tinymce/tinymce-react';
import {Tooltip} from 'react-tooltip';
import { FiSearch, FiCopy, FiCheck, FiUsers, FiImage } from "react-icons/fi"
import { FaRegLightbulb, FaClipboardList, FaTools, FaCog } from 'react-icons/fa';
import { IoSaveOutline, IoBrushOutline, IoDocumentTextOutline } from 'react-icons/io5';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css'; // Add the CSS for styling
import { FiTwitter, FiLinkedin } from 'react-icons/fi';
import ImagesSection from './ImagesSection';
import SeoAudit from './SeoAudit';
import SocialPosts from './SocialPosts';
import { FiBarChart } from 'react-icons/fi';  // Import the desired icon

const ArticleView = () => {
  const [article, setArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState('');
  const [initialContent, setInitialContent] = useState('');
  const [isRewriting, setIsRewriting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState(null);
  const [isSaveButtonActive, setIsSaveButtonActive] = useState(false);
  const [editorDisabled, setEditorDisabled] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState('2.5rem'); // Default sidebar width
  const [selectedTab, setSelectedTab] = useState('');
  const [searchQuery, setSearchQuery] = useState("")
  const [copiedId, setCopiedId] = useState(null)
  const [selectedSocial, setSelectedSocial] = useState('LinkedIn');  // Track the selected social tab

  const AUTOSAVE_INTERVAL = 2000; // Autosave after 2 seconds of inactivity
  const MIN_DISPLAY_TIME = 1000; // Minimum display time for messages (1 second)
  const [showWarning, setShowWarning] = useState(true);  // Add this line
  let saveTimeout = useRef(null);
  let messageTimeout = useRef(null); // Ref to hold the message timeout
  const closeWarning = () => {
    setShowWarning(false); // Hide the warning when the user clicks "Close"
  };

  const handleCopy = (id) => {
    setCopiedId(id)
    // In a real app, this would copy the image URL to clipboard
    setTimeout(() => setCopiedId(null), 2000)
  }


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value); // Update searchQuery as the user types
  };

     // Hardcoded post ideas
     const socialPostIdeas = {
      LinkedIn: [
          {
              title: 'The State of Web Development in 2023',
              content: `I've been analyzing the latest trends in web development, and it's fascinating to see how quickly the landscape is evolving.

              Key observations:
              • React, Vue, and Angular remain dominant, but Svelte and Solid are gaining traction
              • Serverless and edge computing are transforming backend development
              • AI tools are becoming essential parts of the development workflow

              What trends are you most excited about? Share your thoughts below!

              #WebDevelopment #TechTrends #SoftwareEngineering`,
          },
      ],
      Twitter: [
          {
              title: 'Why Edge Computing Matters for Web Developers',
              content: `Edge computing is revolutionizing how we build and deploy web applications. Here's why it matters:

              1. Reduced latency for users worldwide
              2. Enhanced scalability and performance
              3. Better security and privacy by processing data closer to the user

              #EdgeComputing #WebDev #TechTrends`,
          },
      ],
  };

  const handleTabChange = (tab) => {
    setSelectedSocial(tab);
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/draft/${id}/`);
        const data = await response.json();
        setArticle(data.draft);
        const cleanedHTML = data.draft.html;
        const titleHTML = `<h1>${data.draft.title}</h1>`;
        const initialContent = titleHTML + cleanedHTML;
        setEditorContent(initialContent);
        setInitialContent(initialContent);
      } catch (error) {
        console.error('Error fetching article:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    // Clear any existing timeout to prevent multiple autosaves
    if (saveTimeout.current) {
      clearTimeout(saveTimeout.current);
    }

    // Set a new timeout for autosaving
    if (!editorDisabled && editorContent !== initialContent) {
      saveTimeout.current = setTimeout(() => {
        handleAutoSave();
      }, AUTOSAVE_INTERVAL);
    }

    // Cleanup function to clear the timeout when the component unmounts or dependencies change
    return () => {
      if (saveTimeout.current) {
        clearTimeout(saveTimeout.current);
      }
    };
  }, [editorContent, initialContent, editorDisabled]);


  useEffect(() => {
    if (editorContent !== initialContent) {
      setIsSaveButtonActive(true);
    } else {
      setIsSaveButtonActive(false);
    }
  }, [editorContent, initialContent]);

  const handleEditorChange = (content) => {
    if (!editorDisabled) {
      setEditorContent(content);
    }
  };

  // This function will be passed to ImagesSection
  const handleImageSelect = (imageHtml) => {
    console.log("ArticleView.handleImageSelect called with:", imageHtml); // ADD THIS
    if (editorRef.current) {
        editorRef.current.insertContent(imageHtml);
    }
};
  const SidebarContent = ({ selectedTab, draftId, onImageSelect }) => {
    console.log('draftId', draftId);

    switch (selectedTab) {
      case 'Images':
        console.log('Rendering Images content');
        return (
          <ImagesSection onImageSelect={onImageSelect} /> // Pass the onImageSelect function

        );
      case 'Audit':
        console.log('Rendering Audit content');
        return (
          <div className="">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2 p-4">
            <FiBarChart className="text-blue-500" /> {/* Icon next to the title */}
            SEO Audit
          </h2>
                        <SeoAudit draftId={draftId} />
        </div>
        );
      case 'Social':
        console.log('Rendering Social content');
        return (

          <SocialPosts draftId={draftId} />  // Use the SocialPosts component
        );
    }
  };

  const handleSidebarClick = (tab, width) => {
    if (selectedTab === tab) {
      // If the tab is already selected, collapse the sidebar back to 3rem
      setSelectedTab('');
      setSidebarWidth('2.5rem');  // Collapse to 3rem
    } else {
      // If the tab is not selected, expand the sidebar to the selected width
      setSelectedTab(tab);
      setSidebarWidth(width);  // Expand to the desired width
    }
  };

  const rewriteTextWithAI = async (html, option) => {
    setIsRewriting(true);
    try {
      const response = await axios.post('https://trendhopper-c3934b7293e6.herokuapp.com/rewrite/', {
        text: html,  // Send the HTML content to the backend
        option: option,
      });
      return response.data.rewrittenText;
    } catch (error) {
      console.error('Error rewriting this selection:', error);
      alert('Error rewriting text. Please try again.');
      throw error;
    } finally {
      setIsRewriting(false);
    }
  };

  const handleRewriteClick = async (option) => {
    if (!editorDisabled) {
      const selectedHTML = editorRef.current.selection.getNode().outerHTML;
      console.log('selected html', selectedHTML)
      if (selectedHTML) {
        try {
          const aiText = await rewriteTextWithAI(selectedHTML, option);
          if (editorRef.current && aiText) {
            editorRef.current.selection.setContent(aiText);  // Replace the selected content with the rewritten HTML
          }
        } catch (error) {
          console.log('error rewriting', error)
          // Error handling
        }
      } else {
        alert('Please select text to rewrite.');
      }
    }
  };

  const handleAutoSave = async () => {
    if (editorRef.current && !editorDisabled) {
      const htmlContent = editorRef.current.getContent();
      setIsSaving(true);
      setSaveStatus('saving');
      // Clear any existing message timeout
      clearTimeout(messageTimeout.current);

      // Ensure "Saving..." message is shown for at least MIN_DISPLAY_TIME
      messageTimeout.current = setTimeout(() => {
        // The actual save operation is performed *after* the minimum display time
        performSave(htmlContent);
      }, MIN_DISPLAY_TIME);
    }
  }

    const performSave = async (htmlContent) => {
        try {
            const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/drafts/${id}/update_html/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ html: htmlContent }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                setInitialContent(htmlContent);
                setIsSaveButtonActive(false);
                setSaveStatus('saved');
                // Clear any existing message timeout, just in case
                clearTimeout(messageTimeout.current);
                // Set a new timeout to clear the "saved" message after MIN_DISPLAY_TIME
                messageTimeout.current = setTimeout(() => setSaveStatus(null), MIN_DISPLAY_TIME);
            } else {
                console.error('Error saving article HTML:', data.message);
                alert(`Error saving article: ${data.message}`);
                setSaveStatus('error');
                // Also clear after MIN_DISPLAY_TIME in case of error
                messageTimeout.current = setTimeout(() => setSaveStatus(null), MIN_DISPLAY_TIME);
            }
        } catch (error) {
            console.error('Network error while saving article HTML:', error);
            alert('Network error occurred while saving.');
            setSaveStatus('error');
            // Also clear after MIN_DISPLAY_TIME in case of network error
            messageTimeout.current = setTimeout(() => setSaveStatus(null), MIN_DISPLAY_TIME);
        } finally {
            setIsSaving(false);
        }
    }

  const handleSaveClick = async () => {
    // Clear any pending autosave timeout
    clearTimeout(saveTimeout.current);
    await handleAutoSave();  // Reuse the autosave logic, ensuring latest content is saved.  Important to use await here.
  };

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target;
      if (target.tagName === 'A' && editorRef.current && editorRef.current.dom.isChildOf(target, editorRef.current.getBody())) {
        const href = target.getAttribute('href');
        if (href && !href.startsWith('#')) {
          e.preventDefault();
          window.open(href, '_blank', 'noopener,noreferrer');
        }
      }
    };

    if (editorRef.current) {
      const editorBody = editorRef.current.getBody();
      editorBody.addEventListener('click', handleClick);
    }
    return () => {
      if (editorRef.current && editorRef.current.getBody()) {
        const editorBody = editorRef.current.getBody();
        editorBody.removeEventListener('click', handleClick);
      }
    };
  }, [editorRef.current]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader color="#ffffff" size={50} />
      </div>
    );
  }
  return (
    <div className="flex min-h-screen overflow-hidden">
      <div className="bg-gray-900 text-white relative w-full flex flex-col h-screen overflow-hidden">
        {article?.status === 2 && showWarning && (
          <div className="bg-gradient-to-r from-orange-500 to-rose-500 text-white p-3 text-center flex justify-between items-center">
            <div>
              <IoInformationCircleOutline size={18} className="inline-block mr-2" />
              Edits won't be updated on your blog if you have an integration.
            </div>
            <button onClick={closeWarning} className="text-white font-bold">Close</button>
          </div>
        )}

    <div className="flex flex-grow overflow-hidden" > {/* Flex Container for Editor and Sidebar */}
        <div className="prose text-gray-300 w-full max-w-none flex-1 overflow-y-auto h-full relative">
        <Editor
            apiKey="ltv4hrtw95mvqz7a4zkkkqkofhbdyp48i39i8l08qqhsbyl0"
            onInit={(evt, editor) => {
                editorRef.current = editor;
            }}
            value={editorContent}
            onEditorChange={handleEditorChange}
            init={{
                branding: false,
                height: '100%',
                width: '100%',
                menubar: true,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                    'paste',  // Ensure paste plugin is enabled
                    'spellchecker',
                ],
                toolbar: editorDisabled
                    ? false
                    : 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | fontsizeselect', // Removed styleselect from toolbar
                content_style:
                    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; spellcheck: true; }',
                readonly: editorDisabled,
                menu: {
                    file: { title: 'File', items: 'save' },
                    edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
                    view: {
                        title: 'View',
                        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen',
                    },
                    insert: {
                        title: 'Insert',
                        items:
                            'image link media inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime',
                    },
                    format: {
                        title: 'Format',
                        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat | h2 h3 h4 h5 h6', // Added heading options directly to the format menu
                    },
                    tools: {
                        title: 'Tools',
                        items: 'spellchecker spellcheckerlanguage | code wordcount',
                    },
                    table: {
                        title: 'Table',
                        items: 'inserttable | cell row column | advtablesort | tableprops deletetable',
                    },
                    help: { title: 'Help', items: 'help' },
                },
                paste_data_images: true,  // Allow images to be pasted from clipboard
                paste_auto_cleanup_on_paste: true,  // Automatically clean pasted content
                paste_as_text: false,  // Treat pasted content as plain text
                link_default_target: '_blank',
                fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt", // Add this line
                setup: (editor) => {
                    editor.on('Drop', (e) => { //Drop instead of Paste now
                        e.preventDefault(); // Stop browser navigating to image
                        e.stopPropagation();

                        const files = e.dataTransfer.files;

                        if (files && files.length > 0) {

                            for (let i = 0; i < files.length; i++) {
                                const file = files[i];

                                // Only process image files
                                if (file.type.startsWith('image/')) {
                                    const reader = new FileReader();

                                    reader.onload = (event) => {
                                        const imageHtml = `<img src="${event.target.result}" alt="${file.name}" style="max-width: 100%; height: auto;">`;
                                        editor.insertContent(imageHtml);
                                    };

                                    reader.readAsDataURL(file);

                                } else {
                                    console.log("Not an Image")
                                }
                            }
                        }

                    });
                },
            }}
        />

            <div
              className={`fixed top-2 right-2 p-2 rounded-md shadow-lg z-50 text-sm ${
                saveStatus === 'saving' || saveStatus === 'saved'
                  ? 'bg-gray-700 text-white'
                  : ''
              } ${saveStatus === 'error' ? 'bg-red-500 text-white' : ''}`}
            >
              {isSaving && saveStatus === 'saving' && (
                <>
                  <ClipLoader color="#ffffff" size={12} />
                  <span className="ml-2">Saving...</span>
                </>
              )}
              {saveStatus === 'saved' && <span>Saved</span>}
              {saveStatus === 'error' && <span>Error Saving</span>}
            </div>
        </div>
        <div
        className={`bg-white transition-all duration-300 ease-in-out   relative border-l border-gray-300 flex flex-col `}
        style={{ width: `${sidebarWidth}`, maxHeight: '100vh', overflowY: 'auto' }}
    >
         <div 
         className={` flex ${selectedTab ? 'flex-row-reverse': 'flex-row'}`} style={{ height: selectedTab ? '100%' : 'auto' }}
>
        {/* Sidebar Content (Shifted left to make space for icons) */}
        <div className="flex-1 overflow-y-auto pl-12" style={{
          height: '100%',
        }}>
            {article ? (
                <SidebarContent
                  selectedTab={selectedTab}
                  draftId={article.id}
                  onImageSelect={handleImageSelect}  // Pass the function here
                />
            ) : (
                <p>Loading...</p>
            )}
        </div>

        {/* Fixed Icons */}
        <div
            className="absolute top-0 flex flex-col items-center pt-4 w-12"
            style={{
                height: '100%',
                left: sidebarWidth === '2.5rem' ? '50%' : '0',
                transform: sidebarWidth === '2.5rem' ? 'translateX(-50%)' : 'none',
                borderRight: '1px solid rgb(209,213,218)',
            }}
        >
      {/* Images Button (Selected state added) */}
<button
  onClick={() => handleSidebarClick('Images', '23rem')}
  className={`text-gray-500 hover:text-gray-700 mb-4 p-2 rounded-lg transition-all ${selectedTab === 'Images' ? 'bg-blue-600 text-white' : ''
    }`}
  data-tooltip-id="my-tooltip" data-tooltip-content="Images"
>
  <FiImage size={24} />  {/* Replaced with a new icon */}
</button>

{/* SeoAudit Button (Selected state added) */}
<button
  onClick={() => handleSidebarClick('Audit', '23rem')}
  className={`text-gray-500 hover:text-gray-700 mb-4 p-2 rounded-lg transition-all ${selectedTab === 'Audit' ? 'bg-blue-600 text-white' : ''
    }`}
  data-tooltip-id="my-tooltip" data-tooltip-content="SEO Audit"
>
  <FiBarChart size={24} />  {/* Replaced with a new icon */}
</button>

{/* Social Media Button (Selected state added) */}
<button
  onClick={() => handleSidebarClick('Social', '23rem')}
  className={`text-gray-500 hover:text-gray-700 mb-4 p-2 rounded-lg transition-all ${selectedTab === 'Social' ? 'bg-blue-600 text-white' : ''
    }`}
  data-tooltip-id="my-tooltip" data-tooltip-content="Social"
>
  <FiUsers size={24} />  {/* Replaced with a new icon */}
</button>

        </div>
    </div>
    </div>
    </div>

      </div>
      {isRewriting && (
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-800 text-white p-4 rounded-md shadow-lg z-50">
          <ClipLoader color="#ffffff" size={20} />
          <span className="ml-2">Rewriting your selection...</span>
        </div>
      )}
      {/* Tooltip component to render tooltips for buttons */}
      <Tooltip id="my-tooltip" place="left" effect="solid" className="z-50" />
    </div>
  );
};

export default ArticleView;